import { render, staticRenderFns } from "./review-details.vue?vue&type=template&id=29697e7c&"
import script from "./review-details.vue?vue&type=script&lang=js&"
export * from "./review-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports